import React from 'react';
import MenuItem from "@material-ui/core/MenuItem";


export const INTEGER_VALUE_TYPE = 1;
export const FLOAT_VALUE_TYPE =2;
export const DEFAULT_VESPAAN_SERVER={
    "checked":false,
    "descrip":"Main Cloud Server",
    "label":"Car Eyes",
    "type":"Cloud",
    
    //Note the old cloud  IP address was  34.229.118.233
    //On July 4th 2025 I upgraded the EC2 by Rajiv to 184.72.201.194
    //"url":"http://localhost:2500/",
  //"websocketurl":"http://localhost:2500/app",
    
    
     //"url":"http://34.229.118.233:2500/",  //This is for the AWS platewiz/towwatch server
     //"websocketurl":"http://34.229.118.233:2500/app"  //This is for the websocket  AWS platewiz/towwatch server
    
    //"url":"http://www.towwatch.com:2500/",  //This is for the AWS platewiz/towwatch server
    //"websocketurl":"http://www.towwatch.com:2500/app"  //This is for the websocket  AWS platewiz/towwatch server
    
    
      "url":"https://towwatch.com:25005/",  //This is for the AWS platewiz/towwatch server
     "websocketurl":"https://towwatch.com:25005/app"  //This is for the websocket  AWS platewiz/towwatch server
   

};

//"url":"http://34.229.118.233:2500/"


export const USER_TYPE={
    "TOW_TRUCK_AGENT_USER_TYPE":"1",
    "TOW_TRUCK_COMPANY_OWNER_USER_TYPE":"2",
    "VEHICLE_DRIVER_USER_TYPE":"4",
    "VEHICLE_OWNER_USER_TYPE":"8",
    "PROPERTY_OWNER_USER_TYPE":"16",
    "PROPERTY_AGENT_USER_TYPE":"32",
};


export let USER_HLEP_LABEL="User is for those who are not associated with any corporation or agency.";
export let AGENCY_HLEP_LABEL="Agency applies to law enforcement and emergency services/crew. Verification of the agency is required. Example: Police, Fire department" +
    " ,Ambulance.";
export let BUSINESS_HLEP_LABEL="Business applies to any business entity. Verification of the business is required. Example: Towing company, Restaurant " +
    ", Resorts and Golf courses (valet parking services).";

export var  usersTempData = [
    {"id":"u1",
        "firstName":"Farshid",
        "lastName":"Bakhtyari",
        "email":"Bakhtyari@yahoo.com",
        "phone":"617.939.6789999999",
        "userType":"civilian",
        "organizationName":"his family",
        "verificationStatus":"Approved",
        "deleted":false},
    {"id":"u2",
        "firstName":"Fredi",
        "lastName":"Kashani",
        "email":"Kashani@yahoo.com",
        "phone":"617.939.67832423",
        "userType":"civilian",
        "organizationName":"his family",
        "verificationStatus":"Approved",
        "deleted":false}
];

export const vehiclesTempData =[
    {"id":"v1",
        "model":"s69090",
        "userId":"u1",
        "make":"Benz99",
        "year":"190099",
        "color":"Red99",
        "plateNumber":"ERT-76499",
        "state":"Mass",
        "verificationStatus":"Pending",
        "deleted":0},
    {"id":"v2",
        "model":"s69900",
        "userId":"u1",
        "make":"Ford",
        "year":"190099",
        "color":"Red99",
        "plateNumber":"ERT-76499",
        "state":"Mass",
        "verificationStatus":"Pending",
        "deleted":0}
];


export const ACTION_LIST=[
    "Notify Driver",
    "Save Tow",
    "Show Police Notice",
    "Fax Police",
    "Email Police"
     ];

export const VEHICLE_OWNER_ACTION_LIST=[
    "Notify Driver",
    "Immediate Tow",
    "Tow with one time extension",
    "Tow with more time extension",
    "Pending Action",
    "Moved By Owner",
    "Needs to be towed",
    "In Tow Storage"
];

export const MONTHS= [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12"
  ];

export const YEARS= [
    "2023",
    "2024",
    "2025",
    "2026",
    "2027",
    "2028",
    "2029",
    "2030",
    "2031",
    "2032",
    "2033",
    "2034",
    "2035",
    "2036",
    "2037",
    "2038",
    "2039",
    "2040",
    "2041",
    "2042",
    "2043",
    "2044",
    "2045",
    "2046",
    "2047",
    "2048",
    "2049",
    "2050"
];

export const US_STATES= [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming"
];


export const CANADA_STATES= [
    "Alberta",
    "British Columbia",
    "Manitoba",
    "New Brunswick",
    "Newfoundland and Labrador",
    "Nova Scotia",
    "Ontario",
    "Prince Edward Island",
    "Quebec City",
    "Saskatchewan"
];


export const AVAILABLE_COUNTRIES= [
    "U.S.A",
    "Canada"
];

export const VEHICLE_TYPES= [
    "Sedan",
    "Hatchback",
    "Minivan",
    "Van",
    "SUV",
    "Crossover",
    "Coupe",
    "Convertable",
    "Truck",
    "Wagon",
    "Motorcycle",
    "Boat",
    "Other",
];


export const COMPLAINT_TYPES= [
    "Inappropriate",
    "Rude",
    "False Notification",
    "Improper language",
    "Assault",

];


export const MESSAGE_TYPES= [
    "Vehicle is being towed",
    "Vehicle is towed",
    "Flat tire",
    "Window is down",
    "Lights are left on",
    "Hit and run",
    "Door is ajar/open",
    "Reckless driving",
    "Headlights are off",
    "Other",
];


export const TOW_REASONS= [
    "Accident",
    "Abandoned",
    "No Start",
    "Flat Tire",
    "Look out",
    "Tow Zone",
    "Stolen",
    "Snow Removal",
    "Break Down",
    "Unregistered",
    "Out Of Gas",
    "Fire Lane",
    "No Trespass",
    "Arrest",
    "Impounded",
    "Other",
];

//sitekey="6LdjmQ0rAAAAADU4GZUVtQmSXHSH-EBY11cjrAGx" // This is the correct one for my own TowWatch
//sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" //For just testing it's generic dummy one

//This is dummy one for testing
//export let RECAPTCHASITEKEY="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";

//This is real one- use this one on the aws server. This is the good one and real one
export let RECAPTCHASITEKEY="6LdjmQ0rAAAAADU4GZUVtQmSXHSH-EBY11cjrAGx";

//This is for fake localhost testing
//export let RECAPTCHASITEKEY="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";

export function getVehicleOwnerActionList(){
    let actionList = VEHICLE_OWNER_ACTION_LIST.map((s) => {
        return(<MenuItem key={s} value={s}>{s}</MenuItem>);
    });
    return actionList;
}

export function getActionList(){
    let actionList = ACTION_LIST.map((s) => {
        return(<MenuItem key={s} value={s}>{s}</MenuItem>);
    });
    return actionList;
}



export function getTowReasons(){
    let towReasons = TOW_REASONS.map((s) => {
        return(<MenuItem key={s} value={s}>{s}</MenuItem>);
    });
    return towReasons;
}

export function getUSStates(){
    let rusStatesRow = US_STATES.map((s) => {
        return(<MenuItem key={s} value={s}>{s}</MenuItem>);
    });
    return rusStatesRow;
}

export function getMonths(){
    let months = MONTHS.map((s) => {
        return(<MenuItem key={s} value={s}>{s}</MenuItem>);
    });
    return months;
}

export function getYears(){
    let years = YEARS.map((s) => {
        return(<MenuItem key={s} value={s}>{s}</MenuItem>);
    });
    return years;
}

export function getCanadaStates(){
    let canStatesRow = CANADA_STATES.map((s) => {
        return(<MenuItem key={s} value={s}>{s}</MenuItem>);
    });
    return canStatesRow;
}


export function getCountries(){
    let rusStatesRow = AVAILABLE_COUNTRIES.map((s) => {
        // return (<MenuItem label={us} style={{color: 'red'}} key={us} value={us}/>)
        return(<MenuItem key={s} value={s}>{s}</MenuItem>);
    });

    return rusStatesRow;
}



export function getVehicleTypes(){
    let vehicleTypesRow = VEHICLE_TYPES.map((us) => {
        return (<MenuItem label={us} style={{color: 'red'}} key={us} value={us}/>)
    });

    return vehicleTypesRow;
}


export function getMessageTypes(){
    let messageTypesRow = MESSAGE_TYPES.map((us) => {
        return (<MenuItem label={us} style={{color: 'red', fontSize:16}} key={us} value={us}/>)
    });

    return messageTypesRow;
}

export function getComplaintTypes(){
    let complaintTypesRow = COMPLAINT_TYPES.map((us) => {
        return (<MenuItem label={us} style={{color: 'red', fontSize:16}} key={us} value={us}/>)
    });

    return complaintTypesRow;
}



export let  APPLICATION_NAME = "TowWatch";
export let  VEHICLE_NOT_REGISTERED_WITH_PLATEWIZ_STATE = "vehicle_not_registered_with_platewiz_state";
export let  VEHICLE_REGISTERED_WITH_PLATEWIZ_STATE = "vehicle_registered_with_platewiz_state";
export let  VEHICLE_IS_COMMUNITY_VIP_STATE = "vehicle_is_community_vip_state";
export let  VEHICLE_IS_COMMUNITY_MEMBER_STATE = "vehicle_is_community_member_state";
export let  COMMUNITY_BASE_TIME_STATE = "community_base_time_state";
export let  COMMUNITY_URGENT_TOW_STATE = "community_urgent_tow_state";
export let  BASE_TIME_STATE = "notified_immediate_onetime_extension_state";
export let  EXTENDED_TIME_STATE = "notified_multiple_time_extension_state";
//export let  URGENT_TOW_STATE = "urgent_tow_state";
export let  PENDING_CAN_MOVE_BASE_TIME = "pending_state";
export let  PENDING_CAN_MOVE_EXTRA_TIME = "extra pending_state";
export let  COMMUNITY_PENDING_CAN_MOVE_BASE_TIME = "community_pending_state";
export let  VEHICLE_REMOVED_BY_OWNER_STATE = "moved_by_owner_state";
export let  TOW_VEHICLE_STATE = "tow_vehicle_state";
export let  VEHICLE_BEING_TOWED_STATE ="vehicle_being_towed_state";
export let  STORED_IN_STORAGE_LOT_STATE = "stored_in_storage_lot_state";
export let  COMPLETE_STATE = "complete_state";
export let  INVALID_STATE = "invalid_state";
export let CREDIT_CARD_PROCESSING_FAILED_STATE = "credit_card_processing_failed_state";
export let COMMUNITY_VEHICLE_BEING_TOWED_STATE ="community_vehicle_being_towed_state";




export let  TA0_ACTION_TO_NEEDS_TO_BE_TOWED = "ta0_action_to_needs_to_be_towed";
export let  TA1_ACTION_TO_URGENT_TOW = "ta1_action_to_urgent_tow";
export let  TA2_ACTION_TO_BASE_TIME = "ta2_action_to_base_time";
export let  TA3_ACTION_TO_EXTENDED_TIME = "ta3_action_to_extended_time";

export let  TA6_ACTION_TO_MOVED_BY_OWNER = "ta6_action_to_moved_by_owner";
export let  TA7_ACTION_TO_NEEDS_TO_BE_TOWED_TIMER_CANCELLED = "ta7_action_to_needs_to_be_towed_timer_cancelled";
export let  TA8_ACTION_TOWING_TO_STORAGE_LOT = "ta8_action_towing_to_storage_lot";
export let  TA8COM_ACTION_TO_COMMUNITY_VEHICLE_BEING_TOWED = "ta8com_action_community_vehicle_being_towed";

export let  TA10_ACTION_TO_NOTIFY_VIP_MEMBER = "ta10_action_to_notify_vip_member";
export let  TA11_ACTION_TO_COMMUNITY_URGENT_TOW = "ta11_action_to_community_urgent_tow";
export let  TA12_ACTION_TO_COMMUNITY_BASE_TIME  = "ta12_action_to_community_base_time";
export let  TA13_ACTION_TO_COMMUNITY_MOVED_BY_OWNER = "ta13_action_to_community_moved_by_owner";
export let  TA14_ACTION_TO_COMMUNITY_NEEDS_TO_BE_TOWED_TIMER_CANCELLED = "ta14_action_to_community_needs_to_be_towed_timer_cancelled";
export let  TA15_ACTION_TO_VEHICLE_WAS_STORED_IN_STORAGE_LOT = "ta15_action_to_vehicle_was_stored_in_storage_lot";
export let  TA16_ACTION_TO_MOVED_BY_OWNER_EXTENDED_TIME = "ta16_action_to_moved_by_owner_extended_time";
export let  TA17_ACTION_TO_NEEDS_TO_BE_TOWED_TIMER_CANCELLED_EXTENDED_TIME = "ta17_action_to_needs_to_be_towed_timer_cancelled_extended_time";
export let  TA18_ACTION_TO_COMPLETE = "ta18_action_to_complete";
export let  TIMER_EXPIRED_TO_NEEDS_TO_BE_TOWED = "timer_expired_to_needs_to_be_towed";




export let  VO1_ACTION_TO_CANNOT_MOVE = "vo1_action_to_cannot_move";
export let  VO2_ACTION_TO_CAN_MOVE_VEHICLE_IN_BASE_TIME = "vo2_action_to_can_move_vehicle_in_base_time";
export let  VO3_ACTION_TO_CANNOT_MOVE = "vo3_action_to_cannot_move";
export let  VO4_ACTION_TO_CAN_MOVE_VEHICLE_IN_EXTENDED_TIME = "vo4_action_to_can_move_vehicle_in_extended_time";
export let  VO5_ACTION_TO_EXTRA_TIME_SELECTED = "vo5_action_to_extra_time_selected";
export let  VO6_ACTION_TO_COMMUNITY_CANNOT_MOVE = "vo6_action_to_community_cannot_move";
export let  VO7_ACTION_TO_COMMUNITY_CAN_MOVE_VEHICLE_IN_BASE_TIME = "vo7_action_to_community_can_move_vehicle_in_base_time";



export let  SE_ACTION_NONE = "se_action_none";
export let  SE0_ACTION_COMMUNITY_MEMBER= "se0_community_member";
export let  SE0_ACTION_COMMUNITY_VIP_MEMBER= "se0_community_vip";
export let  SE1_ACTION_BASE_TIME_RESPONSE_TIME_EXPIRED = "se1_action_base_time_response_time_expired";
export let  SE2_ACTION_EXTENDED_TIME_RESPONSE_TIME_EXPIRED = "se2_action_extended_time_response_time_expired";
export let  SE3_ACTION_VO_SHOW_BASE_TIME_EXPIRED = "se3_action_vo_show_base_time_expired";
export let  SE4_ACTION_VO_SHOW_EXTENDED_TIME_EXPIRED = "se4_action_vo_show_extended_time_expired";
export let  SE5_ACTION_COMMUNITY_BASE_TIME_RESPONSE_TIME_EXPIRED = "se5_action_community_base_time_response_time_expired";
export let  SE6_ACTION_VO_COMMUNITY_SHOW_BASE_TIME_EXPIRED= "se6_action_vo_community_show_base_time_expired";
export let  SE7_ACTION_CREDIT_CARD_PROCESSING_FAILURE= "se7_action_credit_card_processing_failure";
export let  DISPLAY_SE_ACTION_TO_NEEDS_TO_BE_TOWED = "Action: system issued needs to be towed";


export let DISPLAY_TA0_ACTION_TO_NEEDS_TO_BE_TOWED = "Needs to be towed";
export let DISPLAY_TA1_ACTION_TO_URGENT_TOW = "Urgent tow";
export let DISPLAY_TA2_ACTION_TO_BASE_TIME = "Base time";
export let DISPLAY_TA3_ACTION_TO_EXTENDED_TIME = "Extended time";
export let DISPLAY_TA4_ACTION_TO_PENDING = "Pending";
export let DISPLAY_TA5_ACTION_TO_EXTRA_TIME_GRANTED = "Extra time granted";
export let DISPLAY_TA6_ACTION_TO_MOVED_BY_OWNER = "Moved by owner";
export let DISPLAY_TA7_ACTION_TO_NEEDS_TO_BE_TOWED_TIMER_CANCELLED = "Needs to be towed, timer cancelled";
export let DISPLAY_TA8_ACTION_TOWING_TO_STORAGE_LOT = "Towing to storage lot";
export let DISPLAY_TA8COM_ACTION_TO_COMMUNITY_VEHICLE_BEING_TOWED = "Community Towing to storage lot";
export let DISPLAY_TA9_ACTION_TO_PENDING_EXTRA_TIME_GRANTED = "Pending extra time granted";
export let DISPLAY_TA10_ACTION_TO_NOTIFY_VIP_MEMBER = "Notify vip member";
export let DISPLAY_TA11_ACTION_TO_COMMUNITY_URGENT_TOW = "Community urgent tow";
export let DISPLAY_TA12_ACTION_TO_COMMUNITY_BASE_TIME  = "Community base time";
export let DISPLAY_TA13_ACTION_TO_COMMUNITY_MOVED_BY_OWNER = "Community moved by owner";
export let DISPLAY_TA14_ACTION_TO_COMMUNITY_NEEDS_TO_BE_TOWED_TIMER_CANCELLED = "Community needs to be towed timer cancelled";
export let DISPLAY_TA15_ACTION_TO_VEHICLE_WAS_STORED_IN_STORAGE_LOT = "Vehicle stored in storage lot";
export let DISPLAY_TA16_ACTION_TO_MOVED_BY_OWNER_EXTENDED_TIME = "Moved by owner extended time";
export let DISPLAY_TA17_ACTION_TO_NEEDS_TO_BE_TOWED_TIMER_CANCELLED_EXTENDED_TIME = "Needs to be towed timer cancelled extended time";
export let DISPLAY_TA18_ACTION_TO_COMPLETE = "Complete";
export let DISPLAY_TIMER_EXPIRED_TO_NEEDS_TO_BE_TOWED = "Timer expired to needs to be towed";



export let  DISPLAY_VO1_ACTION_TO_CANNOT_MOVE = "Vehicle owner cannot_move the vehicle";
export let  DISPLAY_VO2_ACTION_TO_CAN_MOVE_VEHICLE_IN_BASE_TIME = "Vehicle owner can move the vehicle in base time";
export let  DISPLAY_VO3_ACTION_TO_CANNOT_MOVE = "Vehicle owner cannot_move the vehicle";
export let  DISPLAY_VO4_ACTION_TO_CAN_MOVE_VEHICLE_IN_EXTENDED_TIME = "Vehicle owner can move the vehicle in extended time";
export let  DISPLAY_VO5_ACTION_TO_EXTRA_TIME_SELECTED = "Vehicle owner select extra time";
export let  DISPLAY_VO6_ACTION_TO_COMMUNITY_CANNOT_MOVE = "Vehicle owner cannot_move the vehicle- community";
export let  DISPLAY_VO7_ACTION_TO_COMMUNITY_CAN_MOVE_VEHICLE_IN_BASE_TIME = "Vehicle owner can move the vehicle in base time- community";

//export let  DISPLAY_SE_ACTION_NONE = "initial";
export let  DISPLAY_SE_ACTION_NONE = "Membership Verified";
export let  DISPLAY_SE0_ACTION_COMMUNITY_MEMBER= "Community member";
export let  DISPLAY_SE0_ACTION_COMMUNITY_VIP_MEMBER= "VIP community member";
export let  DISPLAY_SE1_ACTION_BASE_TIME_RESPONSE_TIME_EXPIRED = "Response time expired";
export let  DISPLAY_SE2_ACTION_EXTENDED_TIME_RESPONSE_TIME_EXPIRED = "Extended response time expired";
export let  DISPLAY_SE3_ACTION_VO_SHOW_BASE_TIME_EXPIRED = "No show time expired";
export let  DISPLAY_SE4_ACTION_VO_SHOW_EXTENDED_TIME_EXPIRED = "No show extended time expired";
export let  DISPLAY_SE5_ACTION_COMMUNITY_BASE_TIME_RESPONSE_TIME_EXPIRED = "Response time expired-community";
export let  DISPLAY_SE6_ACTION_VO_COMMUNITY_SHOW_BASE_TIME_EXPIRED= "No show time expired-community";
export let DISPLAY_SE7_ACTION_CREDIT_CARD_PROCESSING_FAILURE= "Credit card processing failed";


//These are for Parking Incidents
export let PISE0_ACTION_NOT_REGISTERED_WITH_PLATEWIZ = "pise0_action_not_registered_with_platewiz";
export let PISE1_ACTION_TOW_VEHICLE = "pise1_action_tow_vehicle";
export let PISE2_ACTION_REGISTERED_WITH_PLATEWIZ = "pise2_action_registered_with_platewiz";
export let PISE3_ACTION_REGISTERED_WITH_PLATEWIZ_NOT_IN_COMMUNITY = "pise3_action_registered_with_platewiz_not_in_community";
export let PISE4_ACTION_COMMUNITY_GUEST = "pise4_action_community_guest";
export let PISE5_ACTION_COMMUNITY_RESIDENT = "pise5_action_community_resident";
export let PISE6_ACTION_COMMUNITY_BASE_TIME_RESPONSE_TIME_EXPIRED = "pise6_action_community_base_time_response_time_expired";
export let PISE7_ACTION_COMMUNITY_EXTENDED_TIME_RESPONSE_TIME_EXPIRED = "pise7_action_community_extended_time_response_time_expired";
export let PISE8_ACTION_COMMUNITY_BASE_TIME_CAN_MOVE_TIME_EXPIRED = "pise8_action_community_base_time_can_move_time_expired";
export let PISE9_ACTION_COUMMUNITY_CREDIT_CARD_PROCESSING_FAILURE= "pise9_action_community_credit_card_processing_failure";
export let PISE10_ACTION_COMMUNITY_EXTENDED_TIME_CAN_MOVE_TIME_EXPIRED = "pise10_action_community_extended_time_can_move_time_expired";
export let PISE11_ACTION_COUMMUNITY_CREDIT_CARD_PROCESSING_SUCCESSFUL= "pise11_action_community_credit_card_processing_successful";


//export let PITA0_ACTION_TO_NEEDS_TO_BE_TOWED = "pita0_action_to_needs_to_be_towed";
export let PITA1_ACTION_TO_COMMUNITY_URGENT_TOW = "pita1_action_to_community_urgent_tow";
export let PITA2_ACTION_TO_COMMUNITY_BASE_TIME = "pita2_action_to_community_base_time";
export let PITA3_ACTION_TO_COMMUNITY_EXTENDED_TIME = "pita3_action_to_community_extended_time";
export let PITA4_ACTION_TO_PENDING = "pita4_action_to_pending";
export let PITA5_ACTION_TO_EXTRA_TIME_SELECTED = "pita5_action_to_extra_time_selected";
export let PITA6_ACTION_TO_MOVED_BY_OWNER = "pita6_action_to_moved_by_owner";
export let PITA7_ACTION_TO_NEEDS_TO_BE_TOWED_TIMER_CANCELLED = "pita7_action_to_needs_to_be_towed_timer_cancelled";
export let PITA8_ACTION_ESCLATE_TO_TOW_VEHICLE = "pita8_action_esclate_to_tow_vehicle";
export let PITA15_ACTION_TO_CALL_TOW_COMPANY = "pita15_action_to_call_tow_company";
export let PITA16_ACTION_TO_MOVED_BY_OWNER_EXTENDED_TIME = "pita16_action_to_moved_by_owner_extended_time";
export let PITA17_ACTION_TO_NEEDS_TO_BE_TOWED_TIMER_CANCELLED_EXTENDED_TIME = "pita17_action_to_needs_to_be_towed_timer_cancelled_extended_time";
export let PITA18_ACTION_TO_COMPLETE = "pita18_action_to_complete";


export let PIVO1_ACTION_TO_COMMUNITY_CANNOT_MOVE = "pivo1_action_to_cannot_move";
export let PIVO2_ACTION_TO_COMMUNITY_CAN_MOVE_VEHICLE_IN_BASE_TIME = "pivo2_action_to_can_move_vehicle_in_base_time";
export let PIVO3_ACTION_TO_COMMUNITY_CANNOT_MOVE = "pivo3_action_community_to_cannot_move";
export let PIVO4_ACTION_TO_COMMUNITY_CAN_MOVE_VEHICLE_IN_EXTENDED_TIME = "pivo4_action_to_community_can_move_vehicle_in_extended_time";
export let PIVO5_ACTION_TO_COMMUNITY_EXTRA_TIME_SELECTED = "pivo5_action_to_extra_time_selected";



//These are for Parking Incidents
export let DISPLAY_PISE0_ACTION_NOT_REGISTERED_WITH_PLATEWIZ = "Not registered with TowWatch";
export let DISPLAY_PISE1_ACTION_TOW_VEHICLE = "Tow Vehicle";
export let DISPLAY_PISE2_ACTION_REGISTERED_WITH_PLATEWIZ = "Registered with TowWatch";
export let DISPLAY_PISE3_ACTION_REGISTERED_WITH_PLATEWIZ_NOT_IN_COMMUNITY = "Not part of property";
export let DISPLAY_PISE4_ACTION_COMMUNITY_GUEST = "Property Guest";
export let DISPLAY_PISE5_ACTION_COMMUNITY_RESIDENT = "Community Resident";
export let DISPLAY_PISE6_ACTION_COMMUNITY_BASE_TIME_RESPONSE_TIME_EXPIRED = "VO Response Time Expired";
export let DISPLAY_PISE7_ACTION_COMMUNITY_EXTENDED_TIME_RESPONSE_TIME_EXPIRED = "Extended time, response time expired";
export let DISPLAY_PISE8_ACTION_COMMUNITY_BASE_TIME_CAN_MOVE_TIME_EXPIRED = "Time to move vehicle expired";
export let DISPLAY_PISE9_ACTION_COMMUNITY_CREDIT_CARD_PROCESSING_FAILURE= "Credit card processing failure";
export let DISPLAY_PISE10_ACTION_COMMUNITY_EXTENDED_TIME_CAN_MOVE_TIME_EXPIRED= "Extended time, move time expired";
export let DISPLAY_PISE11_ACTION_COMMUNITY_CREDIT_CARD_PROCESSING_SUCCESSFUL= "Credit card processing successful";


//export let PITA0_ACTION_TO_NEEDS_TO_BE_TOWED = "pita0_action_to_needs_to_be_towed";
export let DISPLAY_PITA1_ACTION_TO_COMMUNITY_URGENT_TOW = "Private Property Urgent Tow";
export let DISPLAY_PITA2_ACTION_TO_COMMUNITY_BASE_TIME = "Private Property Base Time";
export let DISPLAY_PITA3_ACTION_TO_COMMUNITY_EXTENDED_TIME = "Private Property Extended Time";
export let DISPLAY_PITA4_ACTION_TO_PENDING = "Pending";
export let DISPLAY_PITA5_ACTION_TO_EXTRA_TIME_SELECTED = "Extra Time Selected";
export let DISPLAY_PITA6_ACTION_TO_MOVED_BY_OWNER = "VO moved vehicle";
export let DISPLAY_PITA7_ACTION_TO_NEEDS_TO_BE_TOWED_TIMER_CANCELLED = "PA cancelled timer";
export let DISPLAY_PITA8_ACTION_ESCLATE_TO_TOW_VEHICLE = "Escalate to tow vehicle";
export let DISPLAY_PITA15_ACTION_TO_CALL_TOW_COMPANY = "Call tow company";
export let DISPLAY_PITA16_ACTION_TO_MOVED_BY_OWNER_EXTENDED_TIME = "VO moved vehicle (extended time)";
export let DISPLAY_PITA17_ACTION_TO_NEEDS_TO_BE_TOWED_TIMER_CANCELLED_EXTENDED_TIME = "PA cancelled timer (extended time)";
export let DISPLAY_PITA18_ACTION_TO_COMPLETE = "Complete";


export let DISPLAY_PIVO3_ACTION_TO_CANNOT_MOVE = "VO cannot move vehicle";
export let DISPLAY_PIVO4_ACTION_TO_CAN_MOVE_VEHICLE_IN_EXTENDED_TIME = "Extended time, can_move_vehicle";
export let DISPLAY_PIVO5_ACTION_TO_EXTRA_TIME_SELECTED = "Extra time selected";
export let DISPLAY_PIVO1_ACTION_TO_COMMUNITY_CANNOT_MOVE = "VO cannot move vehicle";
export let DISPLAY_PIVO2_ACTION_TO_COMMUNITY_CAN_MOVE_VEHICLE_IN_BASE_TIME = "VO can move vehicle";





export let websocket_towjob="towjob";
export let websocket_towjob_delete="towjob_delete";
export let websocket_towjob_update="towjob_update";
export let websocket_email="email";
export let websocket_email_delete="email_delete";
export let websocket_email_update="email_update";
export let websocket_fax="fax";
export let websocket_fax_delete="fax_delete";
export let websocket_fax_update="fax_update";
export let websocket_message="message";
export let websocket_message_delete="message_delete";
export let websocket_message_update="message_update";
export let websocket_police="police";
export let websocket_police_delete="police_delete";
export let websocket_police_update="police_update";
export let websocket_policenotice="policenotice";
export let websocket_policenotice_delete="policenotice_delete";
export let websocket_policenotice_update="policenotice_update";
export let websocket_privateproperty="privateproperty";
export let websocket_privateproperty_delete="privateproperty_delete";
export let websocket_privateproperty_update="privateproperty_update";

export let websocket_privatevehicle="privatevehicle";
export let  websocket_privatevehicle_delete="privatevehicle_delete";
export let  websocket_privatevehicle_update="privatevehicle_update";

export let websocket_truck="truck";
export let  websocket_truck_delete="truck_delete";
export let  websocket_truck_update="truck_update";

export let websocket_driver="driver";
export let  websocket_driver_delete="driver_delete";
export let  websocket_driver_update="driver_update";

export let websocket_dispatch="dispatch";
export let websocket_dispatch_delete="dispatch_delete";
export let websocket_dispatch_update="dispatch_update";
export let websocket_upload="upload";
export let websocket_upload_delete="upload_delete";
export let websocket_upload_update="upload_update";
export let websocket_storagelot="storagelot";
export let websocket_storagelot_delete="storagelot_delete";
export let websocket_storagelot_update="storagelot_update";





/*tUSStates(){
    let tempArray=[];
    tempArray.push(<MenuItem label={""}  style={{ color:'red'}}   key=" " value="" />);

    return(tempArray)
}*/
